export default __webpack_public_path__ + "static/media/ic-absent.10c0914b.svg";